import { reactive } from "vue";

export const globalState = reactive({
  isShowSubscription: false, // 是否显示订阅弹窗

  showSubscriptionModal() {
    this.isShowSubscription = true;
  },
  hideSubscriptionModal() {
    this.isShowSubscription = false;
  }
});